import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { Size } from 'src/app/interfaces/size';

@Injectable({
  providedIn: 'root'
})
export class SizesProviderService extends APIProviderService<Size> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Sizes`;
  }
}
